export const iconFontAwesomeFilesFileCirclePlus = (
	<i className="fa-solid fa-file-circle-plus"></i>
);
